import { useState } from "react";

import Typography from "@mui/joy/Typography";
import Stack from "@mui/joy/Stack";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";

import getIcon from "utils/getIcon";
import { ScreenContainerTwoPotato } from "components/ScreenContainerPotato";

import Next from './PotatoNext';


export default function PotatoFancyHands({ onInView }: { onInView: (visibile: boolean, id: string) => boolean }) {
    const [peopleLikeYouHighlighted, setPeopleLikeYouHighlighted] = useState(false);
    const ProjectsLateIcon = getIcon('CalendarMonth');


    const WorkPileIcon = getIcon('AllInbox');
    const IdeaIcon = getIcon('TipsAndUpdates');
    const CompanyIcon = getIcon('Business');
    const HospitalIcon = getIcon('LocalHospital');
    const BackOnTrackIcon = getIcon('Replay');

    const WorkWithTeamIcon = getIcon('GroupAdd');

    function peopleLikeYou() {
        setTimeout(() => {
            setPeopleLikeYouHighlighted(true);
            setTimeout(() => {
                setPeopleLikeYouHighlighted(false);
            }, 700)
        }, 200);
    }


    return (
    <ScreenContainerTwoPotato
                    view="fancy-hands"
                    onInView={onInView}
                    onViewHook={() => peopleLikeYou()}
                    // onInView={(inview) => onInView(inview, 'who-is-this-for')}
                    reversed={true}
                    window={
                        <Stack
                            sx={{
                                //  opacity: 0.3
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundImage: "url(/handmade/gooey-wood.webp);",

                            }}
                        >
                            <Typography
                                level="title-lg"
                                sx={{
                                    backgroundImage: "url(/handmade/gooey-wood.webp);",
                                    // backgroundImage: "url(/ai-grad/town-square-fullsize.jpg);",
                                    // filter: "invert(0.2) brightness(1.2) sepia(0.4)",
                                    filter: !peopleLikeYouHighlighted ? "invert(0.1) brightness(1.2)" : "invert(0.25) brightness(1.3)",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    // opacity: 0.75,
                                    fontWeight: "bold",
                                    backgroundClip: "text",
                                    textFillColor: "transparent;",
                                    transition: "all ease-in-out 0.5s",
                                    fontSize: !peopleLikeYouHighlighted ? { xs: "10rem", md: "14rem" } : { xs: "9.9rem", md: '13.8rem' },
                                    textAlign: "center",
                                    lineHeight: "90%",

                                }}
                            >For You
                            </Typography>

                        </Stack>
                    }
    >

                    <Typography>
                        Let's get something done
     </Typography>

                    <Typography level="title-lg" component="h3" >
                                                                               Fancy Hands is the original personal assistant service
                  </Typography>


                    <Stack>
                        <Typography
                            level="body-lg"
                        >For projects big and small. Personal and Professional.
                        </Typography>

                        <Typography level="body-md">
                            Use us for things like&hellip;
                        </Typography>
                    </Stack>


                    <List>
                        <ListItem>
                            <ListItemDecorator><ProjectsLateIcon /></ListItemDecorator>
                            <ListItemContent>Projects you've been putting off</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><WorkPileIcon /></ListItemDecorator>
                            <ListItemContent>Work that's been piling up</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><IdeaIcon color="success" /></ListItemDecorator>
                            <ListItemContent>Kicking the tires of an idea</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><CompanyIcon /></ListItemDecorator>
                            <ListItemContent>Starting that company</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><HospitalIcon /></ListItemDecorator>
                            <ListItemContent>Scheduling a dentist appointment</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><BackOnTrackIcon color={peopleLikeYouHighlighted ? 'primary' : 'neutral'}
                                sx={{
                                    fontSize: (peopleLikeYouHighlighted ? '20pt' : undefined),
                                    rotate: (peopleLikeYouHighlighted ? '220deg' : '0deg'),
                                    transition: 'all ease-in-out 0.4s'
                                }} /></ListItemDecorator>
                            <ListItemContent>Getting back on track</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><WorkWithTeamIcon /></ListItemDecorator>
                            <ListItemContent>Working with your existing staff</ListItemContent>
                        </ListItem>
                    </List>

            <Next nextId="introducing-dayones" ks="But it's so much more than that" />
                </ScreenContainerTwoPotato>

    );
}
